<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Payment</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="subscription" v-if="jobPostingPrice && justJobPostingPrice">
        <StripePaymentForm
          :jobPostingPrice="jobPostingPrice"
          :justJobPostingPrice="justJobPostingPrice"
          :jobId="jobId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeMount } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "@/components/Vendor/Element";
import { useStore } from "vuex";
// import StripePaymentForm from "@/components/MarketplaceJobs";
import StripePaymentForm from "@/components/Stripe/StripePaymentForm";
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    StripePaymentForm,
  },
  directives: {},
  setup() {
    const $router = useRouter();
    const $route = useRoute();
    const $store = useStore();
    const userData = $store.getters.GET_USER_DATA;
    console.log("🚀 ~ setup ~ userData:", userData);
    const freeJobPosts =
      userData.jobListingSubscriptionDetails.remainingFreeJobListings;
    console.log("🚀 ~ setup ~ freeJobPosts:", freeJobPosts);
    const justJobPostingPrice = ref("");
    const jobPostingPrice = ref(0);
    const usedFreeJobListings =
      userData.jobListingSubscriptionDetails.usedFreeJobListings;
    console.log("🚀 ~ setup ~ jobPostingPrice:", jobPostingPrice);
    const subscription = ref(
      userData.calculatedSubscriptions &&
        userData.calculatedSubscriptions.subscription
        ? userData.calculatedSubscriptions.subscription
        : 0
    );

    const jobId = ref(null);
    const goBack = () => {
      $router.push({
        name: "edit_job_list",
      });
    };

    const submitJobPost = () => {
      (async () => {
        try {
          const response = await $store.dispatch(
            "UPDATE_JOB_POST_WITH_PAYMENT",
            { jobId: jobId.value }
          );
          // const response = await $store.dispatch("SAVE_JOB_POST", 'publish');
          $store.dispatch("clearJobListingCreatePageData");
          if (response.success) {
            ElMessage({
              type: "success",
              message: "Job has been published successfully",
            });

            $router.push({
              name: "job_lisiting_payment_completed",
            });
          }
        } catch (error) {
          console.log(error);
        }
      })();
    };

    onMounted(() => {
      jobId.value = $route.params.jobId;
    });
    onBeforeMount(() => {
      $store
        .dispatch("GET_JOB_POST_PRICE_INFOS")
        .then((data) => {
          jobPostingPrice.value = data.jobPostingPrice;
          justJobPostingPrice.value = data.justJobPostingPrice;
        })
        .catch((error) => {
          console.error("Error fetching job post price info:", error);
        });
    });

    return {
      goBack,
      submitJobPost,
      freeJobPosts,
      jobPostingPrice,
      usedFreeJobListings,
      subscription,
      jobId,
      justJobPostingPrice,
    };
  },
};
</script>
